import isNil from 'ramda/src/isNil'

export default (inputRef, setListOpen) => {
	if (!isNil(inputRef)) {
		const currentInput = inputRef.current
		currentInput.value = ''
	}
	setListOpen(false)
}
